import api from "../../../api/api";

/** Form C-S prefill */
export const getTaxPrefill = (body) => api.post("/iras/tax/prefill", body);

/** Retrieve saved Form C-S draft (uen required; ya optional) */
export const getTaxDraft = (params) =>
  api.get("/iras/tax/draft", { params });

/** Persist Form C-S draft (filingInfo.uen and filingInfo.ya required) */
export const saveTaxDraft = (body) => api.post("/iras/tax/save-draft", body);

/** Form C-S submission */
export const submitFormCS = (body, config) =>
  api.post("/iras/tax/submit-form-cs", body, config);

/** Form C-S submission history by company id */
export const getCompanySubmissionHistory = (companyId) =>
  api.get(
    `/iras/tax/company-submission-history/${encodeURIComponent(companyId)}`
  );

/** Form C-S submission history record by id (payload + IRAS response) */
export const getSubmissionHistoryById = (submissionId) =>
  api.get(
    `/iras/tax/submission-history/${encodeURIComponent(submissionId)}`
  );

/** IRAS module status (response shape differs from successResponse wrapper) */
export const getIrasApiStatus = () => api.get("/iras/api/status");
